import { Link } from '@/components/Link';

const getLinkProps = (to?: string, openInNewPage?: boolean) => {
  return to ? { component: Link, to: to, target: openInNewPage ? '_blank' : '_self' } : {};
};

export default getLinkProps;
